﻿import * as React from "react";

export interface ITextDisplayProps {
    title: string;
    value: string;
}

export const TextDisplay: React.FunctionComponent<ITextDisplayProps> = (
    props,
): React.ReactElement => (
    <div className={`text-display`}>
        <div className={`text-display-title`}>{props.title}</div>
        <div className={`text-display-value`}>{props.value}</div>
    </div>
);
